import userResources from "api/userResources";
import InputField from "components/fields/InputField";
import Logo from "components/Home/Logo/Logo";
import SubmitButton from "components/SubmitButton/SubmitButton";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  FaGlobe,
  FaMailBulk,
  FaMapMarkerAlt,
  FaPhone,
  FaPhoneAlt,
} from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { MdOutgoingMail } from "react-icons/md";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { toast } from "react-toastify";
import { logo2 } from "utils/images";
import { logo3 } from "utils/images";
import { logo1 } from "utils/images";
import { enquiryFormImg } from "utils/images";

const contactInfo = [
  {
    icon: <FaMailBulk size={25} className="mr-2 text-[#ff4e41]" />,
    text: (
      <a
        href="mailto:travelsystem@gmail.com?subject=Enquiry&body=Hello, I would like to inquire about your services."
        className="hover:text-blue-500 hover:underline"
      >
        travelsystem@gmail.com
      </a>
    ),
  },
  {
    icon: <FaPhoneAlt size={25} className="mr-2 text-[#ff4e41]" />,
    text: (
      <a
        href="tel:+19056781200"
        className="hover:text-blue-500 hover:underline"
      >
        +1- 905-678-1200
      </a>
    ),
  },
  {
    icon: <FaGlobe size={25} className="mr-2 text-[#ff4e41]" />,
    text: (
      <a
        href="https://www.maharajaflights.com/"
        className="hover:text-blue-500 hover:underline"
      >
        www.maharajaflights.com
      </a>
    ),
  },
];

const Enquiry = () => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const [phoneNumber, setPhoneNumber] = useState();
  const [disabled, setDisabled] = useState(false);

  const onSubmit = async (data) => {
    setDisabled(true);
    try {
      const response = await userResources.instaEnquiry(data);

      // Show success toast message
      toast.success(
        "Thank you for contacting us! Your enquiry has been submitted. We will connect with you as soon as possible."
      );
      reset();
      setDisabled(false);
      setPhoneNumber(null);
    } catch (error) {
      setDisabled(false);
      // Show error toast message
      toast.error("Something went wrong. Please try again later.");
      setDisabled(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-100 to-[#ff4e41] p-4">
      <div className="grid w-full max-w-6xl grid-cols-1 items-end gap-4 rounded-lg bg-white p-8 shadow-lg lg:grid-cols-2">
        <div>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="grid grid-cols-1 items-end gap-2 md:grid-cols-2"
          >
            {/* Full Name */}
            <Logo logo1={logo1} logo2={logo2} logo3={logo3} />
            <h2 className="text-center text-2xl font-bold text-gray-900 sm:text-left">
              Flight Booking Enquiry
            </h2>
            <InputField
              label="Full Name"
              id="full_name"
              name="full_name"
              placeholder="Enter your full name"
              type="text"
              register={register}
              rules={{ required: "Full Name is required" }}
              errorMessage={errors.full_name?.message}
            />

            {/* Email */}
            <InputField
              label="Email Address"
              id="email"
              name="email"
              placeholder="Enter your email address"
              type="email"
              register={register}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Enter a valid email address",
                },
              }}
              errorMessage={errors.email?.message}
            />
            <div>
              <label
                htmlFor="phone"
                className="my-2 block text-sm font-medium text-gray-900 dark:text-[#ff4e41]"
              >
                Phone Number
              </label>
              <div className="relative">
                <div className="flex">
                  <PhoneInputWithCountrySelect
                    defaultCountry="CA"
                    value={phoneNumber}
                    onChange={(value) => {
                      setPhoneNumber(value);
                      setValue("phone", value); // Update the useForm state
                    }}
                    placeholder="Enter Phone Number"
                    className="w-full rounded-md border p-2 text-lg focus:outline-none focus:ring-2 dark:!border-white/10"
                  />
                </div>
                {/* <div className="absolute right-4 top-4">
                  <FaPhone />
                </div> */}
              </div>
              {errors.phone && (
                <span className="text-sm text-red-600">
                  {errors.phone.message}
                </span>
              )}
            </div>

            {/* Departure City */}
            <InputField
              label="Departure City"
              id="departure_city"
              name="departure_city"
              placeholder="Enter your departure city"
              type="text"
              register={register}
              rules={{ required: "Departure City is required" }}
              errorMessage={errors.departure_city?.message}
            />

            {/* Destination City */}
            <InputField
              label="Destination City"
              id="destination_city"
              name="destination_city"
              placeholder="Enter your destination city"
              type="text"
              register={register}
              rules={{ required: "Destination City is required" }}
              errorMessage={errors.destination_city?.message}
            />

            {/* Travel Date */}
            <InputField
              label="Travel Date"
              id="travel_date"
              name="travel_date"
              placeholder="Select your travel date"
              type="date"
              register={register}
              rules={{ required: "Travel Date is required" }}
              errorMessage={errors.travel_date?.message}
            />

            {/* Return Date (Optional) */}
            <InputField
              label="Return Date"
              id="return_date"
              name="return_date"
              placeholder="Select your return date"
              type="date"
              register={register}
              rules={{}}
              errorMessage={errors.return_date?.message}
            />

            {/* Number of Passengers */}
            <InputField
              label="Number of Passengers"
              id="no_of_passengers"
              name="no_of_passengers"
              placeholder="Enter number of passengers"
              type="number"
              register={register}
              rules={{ required: "Number of Passengers is required" }}
              errorMessage={errors.no_of_passengers?.message}
            />
            <InputField
              label="Message"
              id="message"
              name="message"
              placeholder="Enter your message"
              type="text"
              isTextArea={true} // Use textarea for the message field
              register={register}
              rules={{
                maxLength: {
                  value: 100,
                  message: "Message cannot exceed 500 characters",
                },
              }}
              errorMessage={errors.message?.message} // Display validation error message
            />

            {/* Submit Button */}
            <div className="">
              {/* <button
                type="submit"
                className="mb-2 w-full rounded-lg bg-[#ff4e41] px-4 py-2 font-semibold text-white transition duration-200 hover:bg-[#810f13]"
              >
                Submit Enquiry
              </button> */}
              <SubmitButton
                disabled={disabled}
                add="Submit Enquiry"
                extraClass="btn w-full border-0 mb-1.5"
              />
            </div>
          </form>
        </div>

        {/* Image Section for Larger Screens */}
        <div className="flex flex-col justify-between gap-2">
          <div className="flex cursor-pointer flex-col items-center justify-center gap-2 text-gray-700 lg:hidden">
            <FaPhoneAlt size={25} className="mr-2 text-[#ff4e41]" />
            <p className="cursor-pointer text-center text-xs hover:text-blue-500 hover:underline">
              <a href="tel:+19056781200">+1- 905-678-1200</a>
            </p>
          </div>
          <div className="hidden  cursor-pointer flex-col items-center justify-center gap-2 text-gray-700 lg:flex">
            <FaMapMarkerAlt size={25} className="mr-2 text-[#ff4e41]" />
            <p className=" cursor-pointer text-center text-xs hover:text-blue-500 hover:underline">
              <a
                href="https://maps.app.goo.gl/GcR8NQwcP5cQvexn6"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500 hover:underline"
              >
                UNIT 12, 4550 EBENEZER RD BRAMPTON ONTARIO L6P 1H4, Canada
              </a>
            </p>
          </div>

          <div className="mb-4 grid grid-cols-2 gap-4 text-center lg:grid-cols-3 lg:text-left">
            {contactInfo.map((info, index) => (
              <div
                key={index}
                className={`mt-2 flex cursor-pointer flex-col items-center justify-center gap-2 text-gray-700 ${
                  index === 1 ? "hidden lg:flex" : ""
                }`}
              >
                {info.icon}
                <p className="cursor-pointer text-center text-xs hover:text-blue-500 hover:underline">
                  {info.text}
                </p>
              </div>
            ))}
          </div>
          <div className="flex cursor-pointer  flex-col items-center justify-center gap-2 text-gray-700 lg:hidden">
            <FaMapMarkerAlt size={25} className="mr-2 text-[#ff4e41]" />
            <p className=" cursor-pointer text-center text-xs hover:text-blue-500 hover:underline">
              <a
                href="https://maps.app.goo.gl/GcR8NQwcP5cQvexn6"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-500 hover:underline"
              >
                UNIT 12, 4550 EBENEZER RD BRAMPTON ONTARIO L6P 1H4, Canada
              </a>
            </p>
          </div>
          <div>
            <img
              src={enquiryFormImg}
              alt="Travel Enquiry"
              className="hidden h-auto w-full rounded-lg shadow-md lg:flex"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Enquiry;
